// 用户数据
export const userData = {
  id: 1,
  name: "pigStar",
  email: "pigStar@gmail.com",
  avatar: "https://tu.tuhemmei.com/zb_users/upload/2023/06/20230613168661723",
  bio: "这个人很神秘，什么也没留下。",
  description: "欢迎来到我的博客！请登陆后完善您的个人信息！",
  techStack: ["暂无"],
  hobbies: ["暂无"],
  github: "#",
  website: "#",
  joinDate: "2025-01-01"
};

// 文章数据
export const posts = [
  {
    id: 1,
    title: "大二碎记：在校园的烟火里，捡拾成长的星光",
    date: "2025-12-22",
    tags: ["大二", "校园"],
    category: "生活随笔",
    content: "大二的时光就像夜空中闪烁的星星，看似遥远却近在咫尺。在教室与宿舍之间穿梭，在图书馆的角落里沉淀，每一刻都是成长的诗篇...",
    excerpt: "大二的时光就像夜空中闪烁的星星，看似遥远却近在咫尺...",
    readTime: "5分钟",
    views: 156
  },
  {
    id: 2,
    title: "武汉美食打卡全攻略：在烟火气里吃透江湖味",
    date: "2025-12-22",
    tags: ["美食", "武汉", "攻略"],
    category: "旅行美食",
    content: "武汉，一座充满江湖气的城市。清晨的热干面，午后的豆皮，夜晚的烧烤大排档...",
    excerpt: "武汉，一座充满江湖气的城市。清晨的热干面，午后的豆皮...",
    readTime: "8分钟",
    views: 234
  }
];

// 归档数据
export const archives = {
  "2025年12月": [
    {
      id: 1,
      title: "大二碎记：在校园的烟火里，捡拾成长的星光",
      date: "2025-12-22",
      tags: ["大二", "校园"]
    },
    {
      id: 2,
      title: "武汉美食打卡全攻略：在烟火气里吃透江湖味",
      date: "2025-12-22",
      tags: ["美食", "武汉", "攻略"]
    }
  ]
};